import { useLead } from 'hooks/useLead'

const useOtherDebts = () => {
  const lead = useLead()

  return lead.otherDebts
}

export { useOtherDebts }
